import { ALL_SERVICE_STATUS } from "./all-service-status.query";
import { IAllServiceStatusResponse } from "./all-service-status.interface";
import { SERVICE_STATUS_VALUES } from "../../config/params";
import { useAllServiceStatusStore } from "../../hooks";
import { useEffect } from "react";
/* eslint-disable max-len */
import { useLazyQuery } from "@apollo/client";

export const useAllServiceStatus = () => {
  const [getAllServiceStatus, { data, loading, error }] = useLazyQuery<{
    getAllServiceStatus: IAllServiceStatusResponse;
  }>(ALL_SERVICE_STATUS, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "network-only",
  });
  const {
    setDropoffServiceStatus,
    setServiceStatusStoreUpdated,
    setWellnessServiceStatus,
    setIntegratedServiceStatus,
    setExpressServiceStatus,
    setOnlinePharmacyServiceStatus,
    isServiceStatusStoreUpdated,
  } = useAllServiceStatusStore();

  const getAllServicesStatus = () => {
    getAllServiceStatus({
      variables: {
        serviceNames: [
          SERVICE_STATUS_VALUES.DROPOFF_VISIT_SERVICE,
          SERVICE_STATUS_VALUES.INTEGRATED_FLOW_SERVICE,
          SERVICE_STATUS_VALUES.EXPRESS_VISIT_SERVICE,
          SERVICE_STATUS_VALUES.WELLNESS_PLAN_SERVICE,
          SERVICE_STATUS_VALUES.ONLINE_PHARMACY_SERVICE,
        ],
      },
    });
  };

  useEffect(() => {
    if (!isServiceStatusStoreUpdated && data) {
      setServiceStatusStoreUpdated(true);
      const dropOffStatus = data?.getAllServiceStatus?.items.filter(
        (service: any) =>
          service.serviceName === SERVICE_STATUS_VALUES.DROPOFF_VISIT_SERVICE,
      )[0]?.isActive;
      const wellnessStatus = data?.getAllServiceStatus?.items.filter(
        (service: any) =>
          service.serviceName === SERVICE_STATUS_VALUES.WELLNESS_PLAN_SERVICE,
      )[0]?.isActive;
      const integratedFlowStatus = data?.getAllServiceStatus?.items.filter(
        (service: any) =>
          service.serviceName === SERVICE_STATUS_VALUES.INTEGRATED_FLOW_SERVICE,
      )[0]?.isActive;
      const expressFlowStatus = data?.getAllServiceStatus?.items.filter(
        (service: any) =>
          service.serviceName === SERVICE_STATUS_VALUES.EXPRESS_VISIT_SERVICE,
      )[0]?.isActive;
      const onlinePharmacyStatus = data?.getAllServiceStatus?.items.filter(
        (service: any) =>
          service.serviceName === SERVICE_STATUS_VALUES.ONLINE_PHARMACY_SERVICE,
      )[0]?.isActive;

      if (dropOffStatus !== undefined) setDropoffServiceStatus(dropOffStatus);
      if (wellnessStatus !== undefined) setWellnessServiceStatus(wellnessStatus);
      if (integratedFlowStatus !== undefined) setIntegratedServiceStatus(integratedFlowStatus);
      if (expressFlowStatus !== undefined) setExpressServiceStatus(expressFlowStatus);
      if (onlinePharmacyStatus !== undefined) setOnlinePharmacyServiceStatus(onlinePharmacyStatus);
    }
  }, [data]);

  return {
    getAllServicesStatus,
    data: data?.getAllServiceStatus?.items,
    loading,
    error,
  };
};
